class UsersDelegate {
    setIsOpen(isOpen) {
        this.setState((prevState) => {
            return { isOpen };
        });
    }

    setRows(rows) {
        this.setState((prevState) => {
            return { rows };
        });
    }

    setSelectedUser(selectedUser) {
        this.setState({ selectedUser });
    }

    showEditDrawer(user) {
        this.setState({ selectedUser: user, isOpen: true });
    }
}

export default UsersDelegate;
